import { Glossary, Locale, isGlossaryEnabled } from "../lib";

const lowestSpecificity = (locale: Locale): Locale => {
    const firstDashIndex = locale.indexOf("-");
    return firstDashIndex === -1 ? locale : locale.substring(0, firstDashIndex);
};

export const areLocalesInGlossary = (
    glossary: Glossary | undefined,
    sourceLocale: Locale,
    targetLocale: Locale
): boolean => {
    if (!isGlossaryEnabled || !glossary) {
        return false;
    }

    for (const localePair of glossary.locales) {
        if (
            localePair.source === lowestSpecificity(sourceLocale) &&
            localePair.target === lowestSpecificity(targetLocale)
        ) {
            return true;
        }
    }

    return false;
};
